export enum Transactions {
  ApplyStoreCredit = 'apply-store-credit',
  GetCheckout = 'get-checkout',
  GetWallet = 'get-wallet',
  GetAppInstance = 'get-app-instance',
}
